import { render, staticRenderFns } from "./marketplace-table-operation.component.vue?vue&type=template&id=254734e0&scoped=true"
import script from "./marketplace-table-operation.component.vue?vue&type=script&lang=js"
export * from "./marketplace-table-operation.component.vue?vue&type=script&lang=js"
import style0 from "./marketplace-table-operation.component.vue?vue&type=style&index=0&id=254734e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254734e0",
  null
  
)

export default component.exports